module.exports = __webpack_public_path__ + "img/banner-12-5@2x.c7471487.jpg";